import {FAILURE, REQUEST, SUCCESS} from "./action-type";

export const ACTION_TYPES = {
  USERS_SEARCH: 'addFriends/USERS_SEARCH',
  SET_QUERY: 'addFriends/SET_QUERY',
  RESET: 'addFriends/RESET',
  SEND: 'addFriends/SEND',
};

const initialState = {
  usersLoading: false,
  usersData: [],
  query: '',
};


export default (state = initialState, action) => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.USERS_SEARCH):
      return {
        ...state,
        usersLoading: true,
      };
    case REQUEST(ACTION_TYPES.SEND): {
      const {item} = action.meta;
      const data = [...state.usersData];
      const index = data.findIndex(it => it.id === item.id);
      data[index] = {...item, loading: true};
      return {
        ...state,
        usersData: data,
      };
    }
    case SUCCESS(ACTION_TYPES.USERS_SEARCH): {
      const data = action.payload.data.user_list;
      //cancelTokenSource = null;
      return {
        ...state,
        usersLoading: false,
        usersData: data,
      };
    }

    case SUCCESS(ACTION_TYPES.SEND): {
      const {item} = action.meta;
      const data = [...state.usersData];
      const index = data.findIndex(it => it.id === item.id);
      data[index] = {...item, status: 7, loading: false};
      return {
        ...state,
        usersData: data,
      };
    }
    case FAILURE(ACTION_TYPES.SEND): {
      const {item} = action.meta;
      const data = [...state.usersData];
      const index = data.findIndex(it => it.id === item.id);
      data[index] = {...item, status: null, loading: false};
      return {
        ...state,
        usersData: data,
      };
    }
    case FAILURE(ACTION_TYPES.USERS_SEARCH):
      return {
        ...state,
        usersLoading: false,
      };

    case ACTION_TYPES.SET_QUERY:
      return {
        ...state,
        query: action.query,
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};



